import React, { useState, useRef } from 'react';
import ReactDOM from "react-dom";
import Card from "../components/Card";
import Filter from "../components/datatable/Filter";
import SearchInput from "../components/datatable/SearchInput"
import AjaxDynamicDataTable from '@langleyfoxall/react-dynamic-data-table/dist/AjaxDynamicDataTable';
import LoadingIndicator from "../components/datatable/LoadingIndicator";
import EmptyTable from "../components/datatable/EmptyTable";
import Button from "../components/Button";

const DISABLED_FILTER_OPTIONS = {
    active: {
        name: "Active",
        value: 'active',
    },
    disabled: {
        name: "Archived",
        value: 'archived'
    }
}

const CustomerDataTable = () => {
    const dataTableRef = useRef(null);
    const [search, setSearch] = useState("");

    const [disabledFilter, setDisabledFilter] = useState(DISABLED_FILTER_OPTIONS.active.value);

    const renderRowButton = (customer) => {
        return (
            <td>
                <div className={"d-flex justify-content-end align-content-center align-items-center"}>
                    {!!customer.can && customer.can.view === true && (
                        <a className="text-primary cursor-pointer" href={route('customer.show', {customer: customer.id}).toString()}>
                            View
                        </a>
                    )}
                </div>
            </td>
        )
    }

    return (
        <React.Fragment>
            <Card title={"Customers"} classes={"mh-100 border-0"}>
                <div className={"row m-0 mb-4 p-0 d-flex justify-content-xl-between"}>
                    <div className="col-12 col-xl-6 m-0 mb-3 mb-xl-0 p-0 pl-xl-2 order-xl-2">
                        <div className={"d-flex justify-content-between justify-content-xl-end align-items-center"}>
                            <Filter
                                label={"Status:"}
                                value={disabledFilter}
                                options={Object.values(DISABLED_FILTER_OPTIONS)}
                                name={"filter_disabled"}
                                onChange={(value) => setDisabledFilter(value)}
                                classes=""
                            />
                            {can('viewAny', 'user') && (
                                    <Button
                                        href={route('web-api.customer.export', {
                                            searchTerm:         search,
                                            filterDisabled:     disabledFilter,
                                        }).toString()}
                                        label="Export"
                                        classes="ml-4 btn btn-outline-eh-off-black px-3 m-0"
                                    />
                            )}
                            {can('create', 'user') && (
                                    <Button
                                        href={route('customer.create').toString()}
                                        label="Create Customer"
                                        icon="far fa-plus-circle"
                                        classes={"ml-4 btn btn-eh-lilac px-3 m-0"}

                                    />
                            )}
                </div>
                </div>
                    <div className="col-12 col-xl-4 m-0 p-0 pr-xl-2 order-xl-1 d-flex justify-content-start align-items-center">
                        <SearchInput
                            value={search}
                            classes={""}
                            placeholder={"Search..."}
                            onChange={(value) => setSearch(value)}
                        />
                    </div>
                    </div>
                <div className={"row m-0 p-0"}>
                    <div className={"col-12 m-0 p-0"}>
                        <div className="data-table">
                            <AjaxDynamicDataTable
                                apiUrl={route('web-api.customer.data-table').toString()}
                                loadingComponent={<LoadingIndicator />}
                                noDataComponent={<EmptyTable itemName="customers" />}
                                fieldsToExclude={disabledFilter === DISABLED_FILTER_OPTIONS.disabled.value ? [
                                    'id',
                                    'first_name',
                                    'last_name',
                                    'business_name',
                                    'contact_telephone_number_link',
                                    'contact_mobile_number',
                                    'contact_mobile_number_link',
                                    'contact_email_link',
                                    'created_at',
                                    'can',
                                ] : [
                                    'id',
                                    'first_name',
                                    'last_name',
                                    'business_name',
                                    'contact_telephone_number_link',
                                    'contact_mobile_number',
                                    'contact_mobile_number_link',
                                    'contact_email_link',
                                    'created_at',
                                    'deleted_at',
                                    'can',
                                ]}
                                alwaysShowPagination
                                fieldMap={{
                                    id:                         "Account Reference",
                                    customer_name:              "Name",
                                    contact_email:              "Email",
                                    contact_telephone_number:   "Telephone Number",
                                    address_line:               "Address"
                                }}
                                ref={dataTableRef}
                                defaultOrderByField={'customer_name'}
                                defaultOrderByDirection={'asc'}
                                params={{
                                    searchTerm: search,
                                    filterDisabled: disabledFilter,
                                }}
                                buttons={(row) => renderRowButton(row)}
                                dataItemManipulator={(field, value, row) => {
                                    switch (field) {
                                        case 'contact_telephone_number':
                                            if (!!row.contact_telephone_number_link) {
                                                return (
                                                    <a href={row.contact_telephone_number_link} className="text-eh-off-black text-underline">{row.contact_telephone_number}</a>
                                                );
                                            }
                                            break;
                                        case 'contact_email':
                                            if (!!row.contact_email_link) {
                                                return (
                                                    <a href={row.contact_email_link} className="text-eh-off-black text-underline">{row.contact_email}</a>
                                                );
                                            }
                                            break;
                                    }

                                    return <span>{value}</span>;
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Card>
        </React.Fragment>
    );
}

export default CustomerDataTable;

const target = document.getElementById('customers-datatable');
if (target) {
    ReactDOM.render(<CustomerDataTable />, target);
}
